export default {
  formData: state => state.formData,
  patientTypeFlagName: state => (state.formData?.newPatient ?? false) ? 'new' : 'returning',
  selectedAppointmentType: (state, getters, { legacy }) => {
    return legacy.appointmentTypes.find(t => t.appointmentTypeId === state.formData.reason)
  },
  selectedAppointmentTypeFeeInDollars: (state, getters, { legacy }) => {
    const fee = getters.selectedAppointmentTypeFeeInCents
    return fee ? (fee / 100).toFixed(2) : null
  },
  selectedAppointmentTypeFeeInCents: (state, getters, { legacy }) => {
    const type = getters.selectedAppointmentType

    if (!legacy.appointmentTypesEnabled || !type) {
      return
    }
    const config = type.configurations.find(c => c.scheduleId === state.formData.scheduleId)
    const attributes = config.attributes.find(a => config.appointmentTypeConfigurationId === a.appointmentTypeConfigurationId &&
      a.patientType === getters.patientTypeFlagName)

    return attributes?.feeAmount
  }
}
